import { FilterTypes } from 'app/components/filters/types';
import { configuration } from './filter-types/configuration';

const filterConfigurations = configuration.reduce((result, filter) => ({
  ...result,
  ...filter.configuration
}), {});

export const createFilterConfigurations = (advancedSearchType: FilterTypes) => {
  return filterConfigurations[advancedSearchType];
};
